import React, { useState, useRef } from "react";
import { Grid, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { addService } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";
import { IServiceState } from "./interface";



interface IAddProps {
  serviceState: IServiceState;
  setServiceState: (x: IServiceState) => void;
}


const Add = (props: IAddProps) => {

  //props
  const {
    serviceState, setServiceState
  } = props



  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setServiceState({ ...serviceState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="libService"
            label="libellé service"
            value={serviceState.libService}
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>

    </Box>

  );
};


export const initialState = { libService: "" }


const DialogAdd = () => {

  //redux
  const dispatch = useDispatch();

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [serviceState, setServiceState] = useState<IServiceState>(initialState)


  //Fermer la boite de dialog d'ajout d'un service
  const onClose = () => {
    setOpen(false)
  }

  //Ouvrir la boite de dialog d'ajout d'un service
  const handleOpenDialog = () => {
    setOpen(true)
  }

  //Enregistrer un service dans la bd
  const handleSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)
      const apiPayload = {
        libService: serviceState.libService
      }
      const res: any = await apiClient.post(SITEWEB_SERVER_BASE_URL, "/ajouterservice", apiPayload);
      if (res.status === 1) {
        dispatch(addService(res.data))
        successNotify("Action effectuée avec succès");
        setAddLoading(false)
        setServiceState(initialState)
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      console.log("🚀 ~ file: Add.tsx:106 ~ handleSave ~ error:", error)
    }
  }


  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          serviceState={serviceState}
          setServiceState={setServiceState}
        />}
      actionFunc={handleSave}
      title="Service"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



